import { atom } from 'jotai';
import { TProductionSeason } from '../drawerStore';

export const seasonAtom = atom<Partial<TProductionSeason> | boolean>(false);
export const releaseIdAtom = atom<number | false>(false);
